import React from "react";
import TrackVisibility from "react-on-screen";
import { Link } from "react-scroll";
import Counter from "../elements/Counter";
import Pagetitle from "../elements/Pagetitle";
import Skill from "../elements/Skill";

const aboutContent = {
  name: "ROFFO.IO",
  avatarImage: "/images/avatar.png",
  content:
    "Welcome to ROFFO.IO, where I, Davide, passionately craft native iOS and Android apps. As a solo developer, I take pride in bringing you unique digital experiences. Explore my featured apps: Tombola Online, and Calcolapizza, each meticulously designed and coded by yours truly.",
};

const progressData = [
  {
    id: 1,
    title: "Tombola Online",
    percentage: 100,
    progressColor: "#FFD15C",
  },
  {
    id: 2,
    title: "Calcolapizza",
    percentage: 100,
    progressColor: "#FF4C60",
  },
];

const counterData = [
  {
    id: 1,
    title: "Projects completed",
    count: 2,
    icon: "icon-fire",
  },
  {
    id: 2,
    title: "Projects in progress",
    count: 3,
    icon: "icon-cup",
  },
  {
    id: 3,
    title: "Users using our apps",
    count: 120000,
    icon: "icon-people",
  },
  {
    id: 4,
    title: "Awards",
    count: 5,
    icon: "icon-badge",
  },
];

function About() {
  return (
    <section id="about">
      <div className="container">
        <Pagetitle title="About Us" />
        <div className="row">
          <div className="col-md-3">
            <div className="text-center text-md-left">
              <img src={aboutContent.avatarImage} alt={aboutContent.name} />
            </div>
            <div className="spacer d-md-none d-lg-none" data-height="30"></div>
          </div>

          <div className="col-md-9 triangle-left-md triangle-top-sm">
            <div className="rounded bg-white shadow-dark padding-30">
              <div className="row">
                <div className="col-md-6">
                  <p>{aboutContent.content}</p>
                  <div className="mt-3">
                    <div className="mt-4">
                      <Link
                        className="btn btn-default"
                        to="section-contact"
                        spy={true}
                        smooth={true}
                        duration={500}
                      >
                        Contact me
                      </Link>
                    </div>
                  </div>
                  <div
                    className="spacer d-md-none d-lg-none"
                    data-height="30"
                  ></div>
                </div>
                <div className="col-md-6">
                  <p>Main apps percentage of completion</p>
                  {progressData.map((progress) => (
                    <TrackVisibility
                      once
                      key={progress.id}
                      className="progress-wrapper"
                    >
                      <Skill progress={progress} />
                    </TrackVisibility>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="spacer" data-height="70"></div>
        <div className="row fix-spacing">
          {counterData.map((counter) => (
            <div key={counter.id} className="col-md-3 col-sm-6">
              <TrackVisibility once>
                <Counter counterItem={counter} />
              </TrackVisibility>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default About;
